import React from 'react';
import './index.scss';

export default ({ children }) => <div className="title-component"><h1>{ children }</h1></div>;
